import { useLingui } from '@lingui/react/macro';
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Button, Divider, Stack } from '@mui/material';
import { AccountBalanceSummary } from './account_balance_summary.tsx';
import { AccountMenuHeader } from './account_menu_header.tsx';
import { AccountMenuReferral } from './account_menu_referral.tsx';
import { accountMenuSectionDividerSx } from './account_menu_styles.ts';

interface AccountMenuOverviewProps {
  ensName?: string | null;
  ensAvatar?: string | null;
  canWithdraw: boolean;
  showReferral: boolean;
  onDeposit: () => void;
  onWithdraw: () => void;
  onFees?: () => void;
  onDisconnect: () => void;
  onClose: () => void;
}

export function AccountMenuOverview({
  ensName,
  ensAvatar,
  canWithdraw,
  showReferral,
  onDeposit,
  onWithdraw,
  onFees,
  onDisconnect,
  onClose,
}: AccountMenuOverviewProps) {
  const { t } = useLingui();

  return (
    <Stack spacing={1.5}>
      <AccountMenuHeader ensName={ensName} ensAvatar={ensAvatar} />

      <Divider sx={{ ...accountMenuSectionDividerSx, my: 0 }} />

      <Box>
        <AccountBalanceSummary onDeposit={onDeposit} onWithdraw={onWithdraw} onFees={onFees} canWithdraw={canWithdraw} />

        {showReferral ? <AccountMenuReferral onNavigate={onClose} /> : null}
      </Box>
      <Button
        variant="text"
        color="inherit"
        startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
        onClick={onDisconnect}
        fullWidth
        sx={{ justifyContent: 'flex-start', '&:hover': { color: 'error.main', backgroundColor: 'transparent' } }}
      >
        {t({ comment: 'Disconnect wallet button in account menu', message: 'Log out' })}
      </Button>
    </Stack>
  );
}
